module.exports = __webpack_public_path__ + "img/orange-stripe-lily.00181c59.jpg";